import type { ActionInput } from "../ActionInput.js";
import {
  hasArrivedAtLatestPlaceOfSafety,
  hasMcaForm,
  hasPlaceOfSafety,
  hasSection136Form,
  hasSharedForm,
  hasTriageForm,
  incidentIsActive,
  mcaFormCompleted,
  section136FormCompleted,
  userIsIncidentOwner,
} from "../helpers.js";

type ShareFormAction = {
  canShareForm: boolean;
  hasSharedForm: boolean;
};

function canShareForm(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    hasPlaceOfSafety(actionInput) &&
    hasArrivedAtLatestPlaceOfSafety(actionInput) &&
    ((hasSection136Form(actionInput) && section136FormCompleted(actionInput)) ||
      (hasMcaForm(actionInput) && mcaFormCompleted(actionInput)))
  );
}

export function calculateShareActions(
  actionInput: ActionInput,
): ShareFormAction {
  return {
    canShareForm: canShareForm(actionInput),
    hasSharedForm: hasSharedForm(actionInput),
  };
}
